import type {ReactElement} from 'react';

export const FOLDER_CARD_ILLUSTRATION_PATH = 'images/mystuff/folder-card.svg';

export const FOLDER_NAME_INPUT_KEYS = {
  COMMIT: 'Enter',
  CANCEL: 'Escape',
} as const;

/**
 * Pressing any of these means the user chose to edit the seeded name rather than replace it,
 * so the Finder-style type-to-replace window closes.
 */
export const KEYS_THAT_KEEP_SEEDED_FOLDER_NAME: readonly string[] = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Backspace', 'Delete'];

export interface FolderCardProps {
  name: string;
  onClick?: () => void;
  isSelected?: boolean;
  /** A tile drag is hovering the card: shows the selected look so it reads as the place the items will land. */
  isDropTarget?: boolean;
  isShared?: boolean;
  isEditing?: boolean;
  onNameCommit?: (name: string) => void;
  onEditCancel?: () => void;
  moreOptionsSlot?: ReactElement;
  shouldAlwaysShowMoreOptions?: boolean;
}
